<template>
  <div class="policyInfo">
    <div class="info_location">
      <!-- <div class="info_location_img">
        <img src="./../../../assets/location1.png" />
      </div>-->
      <div class="info_location_text">
        <span>首页</span>
        <span>></span>
        <span>政策文件</span>
      </div>
    </div>
    <div class="policyInfo-box">
      <div class="policyInfo-title">
        <p>{{ article.Title }}</p>
      </div>
      <div class="policyInfo-time">
        <p>发布日期：{{ article.Createdate | dataFilter}}</p>
      </div>
      <div class="policyInfo-content">
        <pre>
            {{ article.Summary }}
        </pre>
      </div>
      <div class="policyInfo-file" v-if="!!newFileName">
        <a :href="'http://120.194.216.88:89/UploadFiles/Article/'+newFileName">附件：{{ FileName }}</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      article: {},
      newFileName: "",
      FileName: ""
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      // this.Title = this.$route.query.Title;
      // this.Summary = this.$route.query.Summary;
      // this.Createdate = this.$route.query.Createdate;
      this.$axios({
        url: "api/GetArticleDetail/" + this.$route.query.Id,
        method: "get"
      })
        .then(res => {
          this.article = res.data.article;
          this.newFileName = res.data.article.ArticleFile.NewFileName;
          this.FileName = res.data.article.ArticleFile.FileName;
        })
        .catch(err => {
          console.info(err);
        });
    }
  },
  filters: {
    dataFilter: function(value) {
      if (value) {
        let time = value.substring(value.indexOf("(") + 1, value.length - 2);
        let date = new Date(Number(time));
        let year = date.getFullYear();
        let month = date.getMonth() + 1;
        let day = date.getDate();
        return `${year}-${month < 10 ? "0" + month : month}-${day}`;
      } else {
        return value;
      }

      // let hours = date.getHours();
      // let minutes = date.getMinutes();
      // let seconds = date.getSeconds();
    }
  }
};
</script>

<style lang="scss" scoped>
.policyInfo {
  width: 100%;
  height: auto;
  // background: linear-gradient(360deg, #ffffff, transparent);
  // padding: 20px;
  position: relative;
  // box-shadow: 0 0 10px #000000;
  // border-radius: 10px;
  margin-bottom: 50px;
  .policyInfo-box {
    width: 1200px;
    left: 0;
    right: 0;
    margin: auto;
    height: auto;
    .policyInfo-title {
      width: 100%;
      height: auto;
      p {
        width: 100%;
        line-height: 60px;
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        text-align: center;
        color: #333333;
        padding: 0 20px;
      }
    }
    .policyInfo-time {
      width: 100%;
      height: 80px;
      p {
        line-height: 80px;
        font-size: 16px;
        text-align: center;
      }
    }
    .policyInfo-content {
      width: 100%;
      height: auto;
      padding: 0 80px;
      pre {
        width: 100%;
        height: auto;
        text-align: left;
        white-space: pre-wrap;
        word-wrap: break-word;
        line-height: 30px;
      }
    }
    .policyInfo-file {
      width: 100%;
      height: 50px;
      line-height: 50px;
      font-size: 16px;
      padding: 0 80px;
      a {
        float: left;
        color: #1488cc;
        text-decoration: none;
        cursor: pointer;
        &:hover {
          color: #ff7979;
        }
        &:active {
          color: #1488cc;
        }
      }
    }
  }
}
.info_location_text {
  span {
    color: #666666;
  }
  a {
    color: #666666;
  }
}
</style>
